module.exports = __webpack_public_path__ + "static/04-5d70ee485a9c130a00449c57cefd60ec.jpg";